module.exports = __webpack_public_path__ + "img/google-analytics.efb9798.jpg";